import { Observable } from 'rxjs';
import { MatDialogRef, MatDialog } from '@angular/material';
import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { AppLoadFileComponent } from './app-load-file.component';


@Injectable()
export class AppLoadFileService {

  constructor(private _matDialog: MatDialog) { }

  public open(): Observable<any> {
    let dialogRef: MatDialogRef<AppLoadFileComponent>;
    dialogRef = this._matDialog.open(AppLoadFileComponent, {
      disableClose: true
    });
    return dialogRef.afterClosed().pipe(take(1));
  } 
}